/* Teksty interfejsu: assets/json/i18n/{lang}/js-runtime.json. */
function jst(key, params) {
    var api = typeof globalThis !== 'undefined' ? globalThis.PewniakiI18n : null;
    if (api && typeof api.t === 'function') return api.t(key, params);
    if (typeof module === 'object' && module.exports && typeof require === 'function') {
        var lang = typeof document !== 'undefined' && /^en(?:-|$)/i.test(document.documentElement.lang || '') ? 'en' : 'pl';
        var dict = require('../../json/i18n/' + lang + '/js-runtime.json');
        var text = Object.prototype.hasOwnProperty.call(dict, key) ? String(dict[key]) : key;
        return (params || []).reduce(function (out, value, index) { return out.split('%' + (index + 1)).join(String(value)); }, text);
    }
    return key;
}

/* ANALIZATOR MULTI MULTI — TRYB „MOJ KUPON” (Fala 6B-6D, 26.09.2026, decyzja 1).
 *
 * Kupon Multi Multi to 1-10 liczb, losowanie to 20. Pelny tryb analizatora
 * (20 pol, cechy zestawu) zostaje bez zmian; ten tryb pokazuje tylko miary
 * poprawne dla czesciowego zestawu, liczone na tej samej historii:
 *   - histogram DOKLADNEJ liczby trafien (0..k) w wybranej probie,
 *   - najlepszy wynik i kiedy ostatnio padl,
 *   - ostatnie losowanie z co najmniej jednym trafieniem,
 *   - czestosc kazdej wybranej liczby,
 *   - os czasu (data i GODZINA — Multi Multi losuje dwa razy dziennie).
 * Bez sumy, parzystosci i rozpietosci porownywanej z 20 liczbami, bez
 * „oceny kuponu” i prognoz. Liczby nie trafiaja do adresu ani analityki.
 *
 * Historia: PEWNIAKI_ANALIZATOR_UI.historia (te same pliki co pelny tryb),
 * liczenie: PewniakiHistoria.policz/histogram/zakresDat (sprawdz-historia.js).
 * Test logiki: node bin/test-sprawdz-historia.js (sekcja 6B-6D).
 */
(function (root, doc) {
    'use strict';
    var MAX = 10;

    function en() { return !!doc && /^en(?:-|$)/i.test(doc.documentElement.lang || ''); }
    function T(pl, eng) { return en() ? eng : pl; }
    /** "2026-09-22T22:00:00+02:00" -> "2026-09-22 22:00" — czas lokalny zapisany w pliku, bez przeliczania strefy. */
    function kiedy(d) { var s = d && typeof d.drawn_at === 'string' ? d.drawn_at : ''; return s ? s.slice(0, 10) + (s.length >= 16 ? ' ' + s.slice(11, 16) : '') : ''; }

    /** Tekst pola -> lista 1..10 roznych liczb 1..pula albo null. */
    function czytaj(tekst, pula) {
        var s = String(tekst || '').trim();
        if (!s) { return null; }
        var czesci = s.split(/[\s,;]+/), out = [], bylo = {};
        for (var i = 0; i < czesci.length; i++) {
            if (!/^\d{1,2}$/.test(czesci[i])) { return null; }
            var n = parseInt(czesci[i], 10);
            if (n < 1 || n > pula || bylo[n]) { return null; }
            bylo[n] = true; out.push(n);
        }
        return out.length >= 1 && out.length <= MAX ? out.sort(function (a, b) { return a - b; }) : null;
    }

    /** Czysta ocena: draws w dowolnej kolejnosci, liczby 1..10. */
    function ocen(H, draws, liczby) {
        var lista = (draws || []).slice().sort(function (a, b) { return (Date.parse(b.drawn_at) || 0) - (Date.parse(a.drawn_at) || 0); });
        var wyniki = H.policz(lista, liczby, []);
        var hist = H.histogram(wyniki, liczby.length, 't');
        var najlepszy = 0, kiedyNaj = null, ostatnie = null;
        wyniki.forEach(function (w) {
            if (w.t > najlepszy) { najlepszy = w.t; kiedyNaj = w.d; }
            if (!ostatnie && w.t > 0) { ostatnie = w; }
        });
        if (najlepszy > 0) { kiedyNaj = wyniki.filter(function (w) { return w.t === najlepszy; })[0].d; }
        var czestosc = liczby.map(function (n) {
            var ile = lista.filter(function (d) { return (d.numbers || []).indexOf(n) >= 0; }).length;
            return { n: n, ile: ile };
        });
        return { n: lista.length, zakres: H.zakresDat(lista), hist: hist, najlepszy: najlepszy, kiedyNajlepszy: kiedyNaj, ostatnie: ostatnie, czestosc: czestosc, wyniki: wyniki };
    }

    function el(tag, cls, text) { var x = doc.createElement(tag); if (cls) { x.className = cls; } if (text !== undefined) { x.textContent = text; } return x; }
    function tabela(podpis, naglowki, wiersze) {
        var box = el('div', 'tabela-scroll'), t = el('table', 'tabela'), cap = el('caption', '', podpis), th = el('thead'), tr = el('tr'), tb = el('tbody');
        naglowki.forEach(function (h) { var c = el('th', '', h); c.scope = 'col'; tr.appendChild(c); });
        th.appendChild(tr); t.appendChild(cap); t.appendChild(th);
        wiersze.forEach(function (w) { var r = el('tr'); w.forEach(function (v, i) { var c = el(i === 0 ? 'th' : 'td', i === 0 ? '' : 'liczbowa', String(v)); if (i === 0) { c.scope = 'row'; } r.appendChild(c); }); tb.appendChild(r); });
        t.appendChild(tb); box.appendChild(t); return box;
    }

    function rysuj(cel, o, liczby) {
        while (cel.firstChild) { cel.removeChild(cel.firstChild); }
        var k = liczby.length;
        var karta = el('section', "karta o-3 odstep-2 mm-kupon__wynik");
        karta.setAttribute('data-mm-kupon-podsumowanie', '');
        karta.appendChild(el('h3', '', jst("pages_analizator_kupon_js.0996e0f3bd1f")));
        karta.appendChild(el('p', 'tekst-maly', jst("pages_analizator_kupon_js.b611a16c97c4") + o.n + ' · ' + kiedy({ drawn_at: o.zakres.od }) + ' – ' + kiedy({ drawn_at: o.zakres.do })));
        var naj = el('p', '', '');
        naj.setAttribute('data-mm-najlepszy', String(o.najlepszy));
        naj.textContent = o.najlepszy > 0
            ? jst("pages_analizator_kupon_js.031785e0384a") + o.najlepszy + jst("pages_analizator_kupon_js.8a89ae62c03e") + k + jst("pages_analizator_kupon_js.48a5dff8efc7") + kiedy(o.kiedyNajlepszy) + ').'
            : jst("pages_analizator_kupon_js.6b24a4e9f59a");
        karta.appendChild(naj);
        karta.appendChild(el('p', '', o.ostatnie
            ? jst("pages_analizator_kupon_js.4cfd3d15e89a") + kiedy(o.ostatnie.d) + ' — ' + o.ostatnie.t + jst("pages_analizator_kupon_js.8a89ae62c03e") + k + '.'
            : jst("pages_analizator_kupon_js.6f3e12d84a80")));
        var hw = [];
        for (var i = 0; i <= k; i++) { hw.push([i, o.hist[i]]); }
        karta.appendChild(tabela(jst("pages_analizator_kupon_js.9f2e28cba0ac"), [jst("pages_analizator_kupon_js.3197c652f5e8"), jst("pages_analizator_kupon_js.6d4d5241efb4")], hw));
        karta.appendChild(tabela(jst("pages_analizator_kupon_js.0d960d47d2cd"), [jst("pages_analizator_kupon_js.fcebda49ae5a"), jst("pages_analizator_kupon_js.b603be8c909d")], o.czestosc.map(function (c) { return [c.n, c.ile + ' / ' + o.n]; })));
        var det = el('details', 'odstep-2');
        det.appendChild(el('summary', '', jst("pages_analizator_kupon_js.0f1df7fcf4cf")));
        var os = el('div', 'mm-kupon__os'); os.setAttribute('aria-hidden', 'true');
        o.wyniki.slice(0, 100).reverse().forEach(function (w) { var s = el('span', 'mm-kupon__slupek'); s.style.height = (4 + Math.round(36 * w.t / k)) + 'px'; os.appendChild(s); });
        det.appendChild(os);
        det.appendChild(tabela(jst("pages_analizator_kupon_js.abc5de23f5b1"), [jst("pages_analizator_kupon_js.dcdb24cd5bdb"), jst("pages_analizator_kupon_js.3197c652f5e8")], o.wyniki.slice(0, 100).map(function (w) { return [kiedy(w.d), w.t]; })));
        karta.appendChild(det);
        karta.appendChild(el('p', 'tekst-maly', jst("pages_analizator_kupon_js.56ed538c4756")));
        cel.appendChild(karta);
        cel.hidden = false;
    }

    function uruchom(rootEl) {
        var UI = root.PEWNIAKI_ANALIZATOR_UI, H = root.PewniakiHistoria;
        var tryb = rootEl.querySelector('[data-mm-tryb]'), forma = rootEl.querySelector('[data-mm-kupon-form]');
        var pole = rootEl.querySelector('[data-mm-kupon-liczby]'), okno = rootEl.querySelector('[data-mm-kupon-okno]');
        var blad = rootEl.querySelector('[data-mm-kupon-blad]'), wynik = rootEl.querySelector('[data-mm-kupon-wynik]');
        var pelna = rootEl.querySelector('[data-zestaw-form]'), pelnaWynik = rootEl.querySelector('[data-zestaw-wynik]');
        if (!tryb || !forma || !pole || !okno || !wynik || !pelna || !UI || !H) { return; }
        var pula = Number(rootEl.getAttribute('data-pula')) || 80, cache = {}, zadanie = 0;
        function komunikat(t) { if (blad) { blad.textContent = t || ''; blad.hidden = !t; } }
        function wyczyscWynik(w) { if (w) { while (w.firstChild) { w.removeChild(w.firstChild); } w.hidden = true; } }
        /** Przelaczenie: ukryty formularz traci liczby i wynik — nic niewidocznego nie zostaje. */
        function ustawTryb(kupon) {
            zadanie++;
            forma.hidden = !kupon; pelna.hidden = kupon;
            if (kupon) {
                Array.prototype.forEach.call(pelna.querySelectorAll('[data-zestaw-liczba]'), function (f) { f.value = ''; });
                var e = pelna.querySelector('[data-zestaw-blad]'); if (e) { e.textContent = ''; }
                wyczyscWynik(pelnaWynik);
            } else {
                pole.value = ''; komunikat(''); wyczyscWynik(wynik);
            }
            if (pelnaWynik) { pelnaWynik.hidden = kupon || !pelnaWynik.firstChild; }
        }
        tryb.addEventListener('change', function (e) {
            if (e.target && e.target.name === 'mm-tryb') { ustawTryb(e.target.value === 'kupon'); }
        });
        function licz() {
            var liczby = czytaj(pole.value, pula);
            if (!liczby) { komunikat(jst("pages_analizator_kupon_js.3e636b04058d") + pula + '.'); pole.setAttribute('aria-invalid', 'true'); return; }
            pole.removeAttribute('aria-invalid'); komunikat('');
            var moje = ++zadanie, ile = parseInt(okno.value, 10) || 100;
            wyczyscWynik(wynik);
            wynik.appendChild(el('p', 'tekst-maly', jst("pages_analizator_kupon_js.b5418919ee18"))); wynik.hidden = false;
            var p = cache[ile] || UI.historia(rootEl.getAttribute('data-gra'), ile);
            cache[ile] = p;
            p.then(function (wszystkie) {
                if (moje !== zadanie) { return; }
                var probka = H.deduplikuj(wszystkie, 'multi-multi').lista;
                probka = probka.slice(Math.max(0, probka.length - ile));
                if (!probka.length) { throw new Error('pusto'); }
                rysuj(wynik, ocen(H, probka, liczby), liczby);
                try { rootEl.dispatchEvent(new CustomEvent('pewniaki:narzedzie-uzyte', { bubbles: true, detail: { narzedzie: 'analizator', gra: 'multi-multi' } })); } catch (err) { /* stary silnik */ }
            }).catch(function () {
                delete cache[ile];
                if (moje !== zadanie) { return; }
                wyczyscWynik(wynik);
                wynik.appendChild(el('p', 'blad-pola', jst("pages_analizator_kupon_js.0dead391593c")));
                var b = el('button', 'przycisk', jst("pages_analizator_kupon_js.6495e7b66469")); b.type = 'button'; b.setAttribute('data-mm-kupon-ponow', '');
                b.addEventListener('click', licz);
                wynik.appendChild(b); wynik.hidden = false;
            });
        }
        forma.addEventListener('submit', function (e) { e.preventDefault(); licz(); });
    }

    var api = { czytaj: czytaj, ocen: ocen, MAX: MAX };
    if (typeof module === 'object' && module && module.exports) { module.exports = api; }
    root.PEWNIAKI_MM_KUPON = api;
    if (doc && doc.querySelectorAll) {
        Array.prototype.forEach.call(doc.querySelectorAll('[data-analizator-root][data-gra="multi-multi"]'), function (r) {
            if (r.querySelector('[data-mm-tryb]')) { uruchom(r); }
        });
    }
})(typeof window !== 'undefined' ? window : globalThis, typeof document !== 'undefined' ? document : null);
